import React from "react";
import "./UploadPageImageModal.css";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Dropzone from "react-dropzone";
import { addPageImageApi } from "../../api/pages";

class UploadPageImageModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleCloseCreateModal = this.handleCloseCreateModal.bind(this);
    this.handleEnterCreatingImageUrl = this.handleEnterCreatingImageUrl.bind(
      this
    );
    this.handleFireCreateImage = this.handleFireCreateImage.bind(this);
    this.handleSelectImage = this.handleSelectImage.bind(this);

    this.state = {
      creatingImageUrl: "",
      isCreating: false,
      creatingImageFile: null
    };
  }

  handleCloseCreateModal() {
    this.props.handleCloseModal(false);
    this.setState({
      creatingImageUrl: "",
      isCreating: false,
      creatingImageFile: null
    });
  }

  handleEnterCreatingImageUrl(event) {
    if (this.state.isCreating) {
      return;
    }

    this.setState({
      creatingImageUrl: event.target.value
    });
  }

  handleSelectImage(files) {
    if (files.length < 1) {
      return;
    }

    const file = files[0];

    this.setState({
      creatingImageFile: file
    });
  }

  handleFireCreateImage() {
    const { creatingImageFile, creatingImageUrl } = this.state;

    if (
      creatingImageFile == null &&
      (creatingImageUrl == null || creatingImageUrl === "")
    ) {
      toast.error("Please select an image file/enter image url");
      return;
    }

    this.createPdfIssueRequest(
      this.props.pageID,
      creatingImageFile,
      creatingImageUrl
    );
  }

  async createPdfIssueRequest(pageID, imageFile, imageUrl) {
    this.setState({
      isCreating: true
    });

    try {
      await addPageImageApi(pageID, imageFile, imageUrl);

      this.setState({
        creatingImageUrl: "",
        isCreating: false,
        creatingImageFile: null
      });
      this.props.handleCloseModal(true);
    } catch (e) {
      this.setState({
        isCreating: false
      });

      toast.error(e.toString());
    }
  }

  render() {
    return (
      <Modal
        backdrop="static"
        show={this.props.showCreateModal}
        onHide={this.handleCloseCreateModal}
        centered
      >
        <Modal.Header>
          <Modal.Title>Create a new image</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
            <Row>
              <Col>
                <Form.Control
                  className="upload_page_image_url_from"
                  value={this.state.creatingImageUrl}
                  type="text"
                  placeholder="Image url"
                  onChange={this.handleEnterCreatingImageUrl}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Dropzone
                  disabled={this.state.isCreating}
                  onDrop={this.handleSelectImage}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className={
                        this.state.creatingImageFile == null
                          ? "upload_zone"
                          : "upload_zone_green"
                      }
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <span>
                        {this.state.creatingImageFile == null
                          ? "Drop/Click image file"
                          : this.state.creatingImageFile.name}
                      </span>
                    </div>
                  )}
                </Dropzone>
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.handleCloseCreateModal}
            disabled={this.state.isCreating}
          >
            Close
          </Button>
          <Button
            variant="info"
            onClick={this.handleFireCreateImage}
            disabled={this.state.isCreating}
          >
            Create
          </Button>
          <div className="spinner_container">
            {" "}
            {this.state.isCreating && <Spinner animation="grow" />}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default UploadPageImageModal;
